import Mutations from '../../odata/mutations';

export default { ...new Mutations('packingList'), ...new Mutations('packingLists') };
